// @ts-nocheck


import { downloadRequestWithToken, fetchRequest } from './index';






import CommonApi from './../commonApi';
import { convertFromKopToRub, convertFromRubToKop } from '../pure/unitConversions';
import { convertFromKmToM, convertFromMToKm } from '../pure/unitConversions';








export const convertDataToServer = (
springPassCalculation) => (
{
  ...springPassCalculation,
  plannedKilometrage: convertFromKmToM(
    springPassCalculation.plannedKilometrage
  ),
  passSum: convertFromRubToKop(springPassCalculation.passSum),
  taxSum: convertFromRubToKop(springPassCalculation.taxSum),
  sum: convertFromRubToKop(springPassCalculation.sum),
  excessRate: convertFromRubToKop(springPassCalculation.excessRate),
  taxRate: convertFromRubToKop(springPassCalculation.taxRate),
  months: springPassCalculation.months.map(convertDataToServerMonth)
});

export const convertDataFromServer = (
springPassCalculation) => (
{
  ...springPassCalculation,
  plannedKilometrage: convertFromMToKm(
    springPassCalculation.plannedKilometrage
  ),
  passSum: convertFromKopToRub(springPassCalculation.passSum),
  taxSum: convertFromKopToRub(springPassCalculation.taxSum),
  sum: convertFromKopToRub(springPassCalculation.sum),
  excessRate: convertFromKopToRub(springPassCalculation.excessRate),
  taxRate: convertFromKopToRub(springPassCalculation.taxRate),
  months: springPassCalculation.months.map(convertDataFromServerMonth)
});

export const convertDataToServerMonth = (
springPassCalculationMonth) => (
{
  ...springPassCalculationMonth,
  cost: convertFromRubToKop(springPassCalculationMonth.cost),
  tax: convertFromRubToKop(springPassCalculationMonth.tax)
});

export const convertDataFromServerMonth = (
springPassCalculationMonth) => (
{
  ...springPassCalculationMonth,
  cost: convertFromKopToRub(springPassCalculationMonth.cost),
  tax: convertFromKopToRub(springPassCalculationMonth.tax)
});

let basedUrl = 'springPassCalculation';
export const updateCalculations = async (
vehiclePlanId) =>
{
  const updated = await fetchRequest.put(
    `/${basedUrl}/updateCalculations/${vehiclePlanId}`
  );
  if (updated) return updated;
  throw new Error(`Не удалось отредактировать`);
};

const springPassCalculation = Object.assign(
  new CommonApi(
    basedUrl,
    'Пропуска весенний период',
    convertDataToServer,
    convertDataFromServer
  ),
  {
    calculation: new CommonApi(
      `${basedUrl}/updateCalculation`,
      'Пропуска весенний период',
      convertDataToServer,
      convertDataFromServer
    )
  }
);

const calculate = async (vehiclePlanId) => {
  const updated = await fetchRequest.put(
    `/${basedUrl}/calculate/${vehiclePlanId}`
  );
  if (updated) return updated;
  throw new Error(`Не удалось произвести расчет`);
};

const changeStatus = async (
vehiclePlanId,
status) =>
{
  const updated = await fetchRequest.put(`/${basedUrl}/changeStatus`, {
    vehiclePlanId,
    status
  });
  if (updated) return updated;
  throw new Error(`Не удалось сменить статус`);
};

const print = async (vehiclePlanId, filter) => {
  const printed = await downloadRequestWithToken(`/${basedUrl}/print`, {
    ...filter,
    vehiclePlanId
  });
  if (printed) return printed;
  throw new Error('Не удалось загрузить файл');
};

export default {
  ...springPassCalculation,
  calculate,
  changeStatus,
  updateCalculations,
  print
};
